import { createAsyncThunk } from "@reduxjs/toolkit";
import * as chatApi from "../../api/requests/chat";

export const getAllChats = createAsyncThunk("chat/getAllChats", async () => {
  try {
    const response = await chatApi.getAllChats();
    return response;
  } catch (error) {
    return error;
  }
});

export const getUnreadCounts = createAsyncThunk(
  "chat/getUnreadCounts",
  async () => {
    try {
      const response = await chatApi.getUnreadCounts();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const markAsRead = createAsyncThunk(
  "chat/markAsRead",
  async (chatId) => {
    try {
      const response = await chatApi.makeAsRead(chatId);
      return response;
    } catch (error) {
      return error;
    }
  }
);
